import type { ResolveMapEntry } from './ResolveMapEntry.js';

/**
 * A map of package names to ResolveMapEntry objects.
 */
export type ResolveMap = Record<string, ResolveMapEntry>;
